import { shallowRef } from 'vue'

// ADR-070: backend trả `reauth_required`/`reauth_failed` khi đổi quyền; http.ts hỏi lại mật khẩu rồi gửi lại với header này.
export const REAUTH_HEADER = 'X-Reauth-Password'
export interface ReauthRequest { failed: boolean; resolve: (password: string | null) => void }
export const pendingReauth = shallowRef<ReauthRequest | null>(null)

export function requestReauthPassword(failed = false): Promise<string | null> {
  pendingReauth.value?.resolve(null)
  return new Promise(resolve => {
    pendingReauth.value = { failed, resolve: password => { pendingReauth.value = null; resolve(password) } }
  })
}

export function reauthCode(error: unknown): string | undefined {
  const response = (error as { response?: { status?: number; data?: { code?: unknown } } })?.response
  const code = response?.status === 422 ? response.data?.code : undefined
  return code === 'reauth_required' || code === 'reauth_failed' ? code : undefined
}
